// // import React, { useState } from "react";
// // import { Link } from "react-router-dom";
// // import css from "./videoView.module.css";
// // import YouTube from "react-youtube";
// // import transliterate from "../../function/transliterate";
// // import YouBinIntr from "./youBinIntr";

// // export default function BigVideo({ windowDimensions, data }) {
// //   const [visibleVideos, setVisibleVideos] = useState(3); // Кількість відео, що відображаються

// //   const loadMoreVideos = () => {
// //     setVisibleVideos((prevVisibleVideos) => prevVisibleVideos + 3);
// //   };

// //   return (
// //     <div className={css.bigVideoWrap}>
// //       <div className={css.bigVideoWrapSmall}>
// //         {data &&
// //           data.slice(0, visibleVideos).map((el, index) => {
// //             // Відображаємо лише частину відео
// //             return (
// //               <div className={css.bigWrap} key={index}>
// //                 {windowDimensions && (
// //                   <YouTube
// //                     videoId={`${el.videoId}`}
// //                     opts={{ width: "758px", height: "454px" }}
// //                   />
// //                 )}
// //                 {!windowDimensions && (
// //                   <YouTube
// //                     videoId={`${el.videoId}`}
// //                     opts={{ width: "300px", height: "200px" }}
// //                   />
// //                 )}
// //                 <div className={css.someTextWrap}>
// //                   {el && el.bookName && (
// //                     <Link
// //                       to={`/product/${transliterate(el.bookName)}`}
// //                       className={css.videoViewvH1}
// //                     >
// //                       {el.videoName}
// //                     </Link>
// //                   )}
// //                   {el && !el.bookName && (
// //                     <h1 className={css.videoViewvH1}>{el.videoName}</h1>
// //                   )}
// //                   <p className={css.bigVideoP}>{el.videoDesc}</p>
// //                 </div>
// //               </div>
// //             );
// //           })}

// //         {visibleVideos < data.length && ( // Відображаємо кнопку, лише якщо є більше відео
// //           <button className={css.mareVideo} onClick={loadMoreVideos}>
// //             Більше відео
// //           </button>
// //         )}

// //         <YouBinIntr windowDimensions={windowDimensions} data={data} />
// //       </div>
// //     </div>
// //   );
// // }
// import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import css from "./videoView.module.css";
// import YouTube from "react-youtube";
// import transliterate from "../../function/transliterate";
// import YouBinIntr from "./youBinIntr";
// import { getProductHref } from "../../function/productLink";
// export default function BigVideo({ windowDimensions, data, selectedAge }) {
//   const [visibleVideos, setVisibleVideos] = useState(3);
//   const [filteredVideos, setFilteredVideos] = useState([]);

//   useEffect(() => {
//     if (!selectedAge) {
//       console.log("⚠️ Вікова категорія не обрана, показуємо всі відео.");
//       setFilteredVideos(data);
//       return;
//     }

//     // 🔹 Нормалізуємо вибрану категорію (видаляємо зайві пробіли та приводимо до нижнього регістру)
//     const normalizedSelectedAge = selectedAge
//       .trim()
//       .replace(/\s/g, "")
//       .toLowerCase();
//     console.log("✅ Нормалізована вибрана категорія:", normalizedSelectedAge);

//     const filtered = data.filter((video) => {
//       console.log("🎥 Перевіряємо відео:", video);

//       // 🔹 Якщо немає вікової категорії взагалі — пропускаємо відео
//       if (!video.ageCategory && !video.ageCategories) {
//         console.warn("⚠️ Відео без вікової категорії!", video);
//         return false;
//       }

//       // 🔹 Якщо `ageCategory` — це рядок
//       if (typeof video.ageCategory === "string") {
//         const normalizedVideoAge = video.ageCategory
//           .trim()
//           .replace(/\s/g, "")
//           .toLowerCase();
//         console.log(
//           `🔎 Порівнюємо: "${normalizedVideoAge}" === "${normalizedSelectedAge}"`,
//         );
//         if (normalizedVideoAge === normalizedSelectedAge) return true;
//       }

//       // 🔹 Якщо `ageCategories` — це масив
//       if (Array.isArray(video.ageCategories)) {
//         const matched = video.ageCategories.some((age) => {
//           if (typeof age === "string") {
//             const normalizedAge = age.trim().replace(/\s/g, "").toLowerCase();
//             console.log(
//               `🔎 Порівнюємо в масиві: "${normalizedAge}" === "${normalizedSelectedAge}"`,
//             );
//             return normalizedAge === normalizedSelectedAge;
//           }
//           return false;
//         });

//         if (matched) return true;
//       }

//       return false;
//     });

//     console.log("✅ Відео після фільтрації:", filtered);
//     setFilteredVideos(filtered);
//   }, [selectedAge, data]);

//   const loadMoreVideos = () => {
//     setVisibleVideos((prev) => prev + 3);
//   };

//   return (
//     <div className={css.bigVideoWrap}>
//       <div className={css.bigVideoWrapSmall}>
//         {filteredVideos.length > 0 ? (
//           filteredVideos.slice(0, visibleVideos).map((el, index) => (
//             <div className={css.bigWrap} key={index}>
//               <YouTube
//                 videoId={el.videoId}
//                 opts={{
//                   width: windowDimensions ? "758px" : "300px",
//                   height: windowDimensions ? "454px" : "200px",
//                 }}
//               />
//               <div className={css.someTextWrap}>
//                 {el.bookName ? (
//                   <Link to={getProductHref(el)} className={css.videoViewvH1}>
//                     {el.videoName}
//                   </Link>
//                 ) : (
//                   <h1 className={css.videoViewvH1}>{el.videoName}</h1>
//                 )}
//                 <p className={css.bigVideoP}>{el.videoDesc}</p>
//               </div>
//             </div>
//           ))
//         ) : (
//           <p className={css.noVideosText}>
//             🚫 Відео для цієї вікової категорії немає
//           </p>
//         )}

//         {visibleVideos < filteredVideos.length && (
//           <button className={css.mareVideo} onClick={loadMoreVideos}>
//             Більше відео
//           </button>
//         )}

//         <YouBinIntr windowDimensions={windowDimensions} data={filteredVideos} />
//       </div>
//     </div>
//   );
// }
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import YouTube from "react-youtube";

import css from "./videoView.module.css";
import YouBinIntr from "./youBinIntr";
import { getProductHref } from "../../function/productLink";

const normalizeAge = (value) =>
  String(value || "")
    .trim()
    .replace(/\s+/g, "")
    .toLocaleLowerCase("uk-UA");

export default function BigVideo({ data = [], selectedAge }) {
  const [visibleVideos, setVisibleVideos] = useState(3);

  const filteredVideos = useMemo(() => {
    if (!Array.isArray(data)) {
      return [];
    }

    if (!selectedAge) {
      return data;
    }

    const normalizedSelectedAge = normalizeAge(selectedAge);

    return data.filter((video) => {
      const singleAgeMatches =
        typeof video.ageCategory === "string" &&
        normalizeAge(video.ageCategory) === normalizedSelectedAge;

      const multipleAgesMatch =
        Array.isArray(video.ageCategories) &&
        video.ageCategories.some(
          (age) => normalizeAge(age) === normalizedSelectedAge,
        );

      return singleAgeMatches || multipleAgesMatch;
    });
  }, [data, selectedAge]);

  useEffect(() => {
    setVisibleVideos(3);
  }, [selectedAge]);

  const loadMoreVideos = () => {
    setVisibleVideos((previousValue) => previousValue + 3);
  };

  return (
    <div className={css.bigVideoWrap}>
      <div className={css.bigVideoWrapSmall}>
        {filteredVideos.length > 0 ? (
          filteredVideos.slice(0, visibleVideos).map((video) => (
            <article
              className={css.bigWrap}
              key={video.id || video.uid || video.videoId}
            >
              <div className={css.bigVideoPlayer}>
                <YouTube
                  videoId={video.videoId}
                  className={css.bigYoutube}
                  iframeClassName={css.youtubeIframe}
                  opts={{
                    playerVars: {
                      rel: 0,
                    },
                  }}
                />
              </div>

              <div className={css.someTextWrap}>
                {video.bookName ? (
                  <Link to={getProductHref(video)} className={css.videoViewvH1}>
                    {video.videoName}
                  </Link>
                ) : (
                  <h2 className={css.videoViewvH1}>{video.videoName}</h2>
                )}

                {video.videoDesc && (
                  <p className={css.bigVideoP}>{video.videoDesc}</p>
                )}
              </div>
            </article>
          ))
        ) : (
          <p className={css.noVideosText}>
            Відео для цієї вікової категорії немає
          </p>
        )}

        {visibleVideos < filteredVideos.length && (
          <button
            type="button"
            className={css.mareVideo}
            onClick={loadMoreVideos}
          >
            Більше відео
          </button>
        )}

        <YouBinIntr data={filteredVideos} />
      </div>
    </div>
  );
}
